<template>
  <span :class="classes" style="display: block" @click="$emit('click', $event)">
    <component
      :is="componentName"
      :aria-labelledby="ariaLabelledby"
      :aria-label="ariaLabel"
      :aria-hidden="ariaHidden === true ? 'true' : ariaHidden === false ? 'false' : undefined"
      :role="role"
    />
  </span>
</template>

<script setup lang="ts">
import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'

const props = defineProps({
  icon: {
    type: String,
    required: false,
    default: 'x',
    validator: (value: string) =>
      [
        'app-app',
        'app-archive',
        'app-bullhorn',
        'app-checkbox-checked',
        'app-checkbox-unchecked',
        'app-circled-exclamation-mark',
        'app-digital',
        'app-education',
        'app-external',
        'app-filter',
        'app-hat',
        'app-loader',
        'app-lock',
        'app-pause',
        'app-person',
        'app-play',
        'app-play-triangle',
        'app-preludium',
        'app-search',
        'app-signpost',
        'app-speaker',
        'app-speaker-muted',
        'app-websitevanhetjaar-dark',
        'app-websitevanhetjaar-light',
        'app-youtube',
        'app-clock',
        'app-location-marker',
        'app-euro',
        'arrow-down',
        'arrow-left',
        'arrow-right',
        'arrow-up',
        'basket',
        'bell',
        'birthday-cake',
        'calendar',
        'camera',
        'cart',
        'check',
        'chevron-down',
        'chevron-left',
        'chevron-right',
        'chevron-up',
        'circled-check',
        'circled-facebook',
        'circled-instagram',
        'circled-spotify',
        'circled-twitter',
        'circled-youtube',
        'circled-x',
        'facebook-f',
        'gear',
        'hamburger',
        'heart',
        'heart-filled',
        'instagram',
        'mail',
        'microphone',
        'minus',
        'music-note',
        'pdf-file',
        'pile',
        'phone',
        'piggy-bank',
        'plus',
        'search',
        'twitter',
        'whats-app',
        'x',
      ].includes(value),
  },
  classes: { type: [String, Array, Object], required: false, default: undefined },
  ariaLabel: { type: String, required: false, default: undefined },
  ariaLabelledby: { type: String, required: false, default: undefined },
  ariaHidden: { type: Boolean, required: false, default: undefined },
  role: { type: String, required: false, default: 'graphics-symbol' },
})

defineEmits(['click'])

const componentName = computed(() => `AtomIcon${upperFirst(camelCase(props.icon))}`)
</script>
